// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"19":"header","39":"retailers","119":"store","121":"gallery","279":"hero","348":"footer","441":"requirements","565":"subscriptions-packs","697":"news","720":"faq","735":"embeds","906":"promoSlider","941":"packs"}[chunkId] || chunkId) + ".client-script.js";
};